import React, { useEffect, useState } from 'react';
import { useAppSelector } from '@store/hooks';
import { useAppDispatch } from '@store/index';
import { useTranslation } from 'react-i18next';
import { getVoovAuthInfo } from '@store/authentication/authentication.slice';
import './Account.scss';
import { GUEST_APP_ID } from '@constant/index';
import { fetchAccounts, logout } from '@services/cgi';
import { Dropdown, List } from '@tencent/met-ui';
import { loginInVoov } from '@store/authentication/authentication.trunk';
import { gotoLoginPage, gotoSignPage, gotoUserCenter } from '@utils/navigate';
import { generateAvatar } from '@utils/helper/user';
import { isMobileBrowser } from '@utils/browser';

const Account: React.FC = () => {
  const voovAuthInfo = useAppSelector(getVoovAuthInfo);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [showSwitch, setShowSwitch] = useState(false);

  useEffect(() => {
    if (isLogin) {
      fetchAccounts().then((res) => {
        if (res.code === 0 && res.data?.is_can_change_account) {
          setShowSwitch(true);
        }
      });
    }
  }, [voovAuthInfo?.appid]);

  const isLogin = voovAuthInfo?.appid && voovAuthInfo?.appid !== GUEST_APP_ID;

  const onLogin = () => {
    gotoLoginPage();
  };

  const onSignUp = () => {
    gotoSignPage();
  };

  const onLogout = (close: { (): void; (): void }) => {
    logout().then(() => {
      sessionStorage.clear();
      dispatch(loginInVoov());
    });
    close();
  };
  return (
    <div className="account-com">
      {isLogin ? (
        <>
          <div className="account-com-text account-com-center" onClick={gotoUserCenter}>
            {t('用户中心')}
          </div>
          <Dropdown
            clickClose={false}
            style={{ marginRight: 10 }}
            button={
              <img
                className="account-com-avatar"
                src={generateAvatar({
                  username: voovAuthInfo.nickname || voovAuthInfo.userid,
                  avatar: voovAuthInfo.avatar,
                })}
                alt="avatar"
              />
            }
            appearance="pure"
          >
            {(close) => (
              <List type="option">
                <List.Item onClick={close}>{voovAuthInfo.nickname}</List.Item>
                {showSwitch && <List.Item onClick={close}>{t('切换账号')}</List.Item>}
                <List.Item onClick={() => onLogout(close)}>{t('登出')}</List.Item>
              </List>
            )}
          </Dropdown>
        </>
      ) : (
        <>
          <div
            onClick={onLogin}
            className={`account-com-text account-com-login ${isMobileBrowser() ? 'account-com-phone-login' : ''}`}
          >
            {t('登录')}
          </div>
          <div onClick={onSignUp} className="account-com-reg account-com-text">
            {t('注册')}
          </div>
        </>
      )}
    </div>
  );
};

export default Account;
